import { render, staticRenderFns } from "./manage-worker-dialog.vue?vue&type=template&id=360903dd&scoped=true&"
import script from "./manage-worker-dialog.vue?vue&type=script&lang=js&"
export * from "./manage-worker-dialog.vue?vue&type=script&lang=js&"
import style0 from "./manage-worker-dialog.vue?vue&type=style&index=0&id=360903dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360903dd",
  null
  
)

export default component.exports